import * as React from "react";
import { useGetCountriesQuery } from "../services/country.service";
import { Country } from "../types/country";
import SelectData from "./global/SelectData";

const SelectCountry = ({
  onChange,
  sx,
  value,
  error,
  helperText,
  size,
}: {
  onChange: (arg?: number) => void;
  sx?: any;
  value: number;
  error?: boolean;
  helperText?: React.ReactNode;
  size?: "small" | "medium";
}) => {
  const { data: countries, isLoading } = useGetCountriesQuery();

  return (
    <SelectData
      data={countries}
      getOptionLabel={(country) => country.name}
      getOptionValue={(country) => country.id}
      value={value}
      onChange={(value) => onChange(value as number)}
      label="Country"
      placeholder="Search country..."
      error={error}
      helperText={helperText}
      isLoading={isLoading}
      sx={sx}
    />
  );
};
export default SelectCountry;
